export enum TipologiaQuestionariNonCognitivi {
    paracadute = 'PARACADUTE',
    comune = 'COMUNE',
    followup = 'FOLLOWUP'
}